import commonLoanProposalActionTypes from './common-loan-proposal.types';

/** ***************** GET LOAN PROPOSAL LIST START *********************** */
export const getLoanPropsalListStart = (getData: any) => ({
	type: commonLoanProposalActionTypes.GET_LOAN_PROPOSAL_LIST_START,
	payload: getData,
});

export const getLoanPropsalListSuccess = (successData: any) => ({
	type: commonLoanProposalActionTypes.GET_LOAN_PROPOSAL_LIST_SUCCESS,
	payload: successData,
});

export const getLoanPropsalListFailure = (failureData: any) => ({
	type: commonLoanProposalActionTypes.GET_LOAN_PROPOSAL_LIST_FAILURE,
	payload: failureData,
});

export const getLoanPropsalListResponseResetStart = () => ({
	type: commonLoanProposalActionTypes.GET_LOAN_PROPOSAL_LIST_RESPONSE_RESET,
});

export const getLoanPropsalListResponseChanged = () => ({
	type: commonLoanProposalActionTypes.GET_LOAN_PROPOSAL_LIST_RESPONSE_CHANGED,
});

/** ***************** GET LOAN PROPOSAL LIST END *********************** */

/** ***************** REVERT LOAN INDEX DETAILS START *********************** */
export const revertLoanIndexDetailsStart = (revertData: any) => ({
	type: commonLoanProposalActionTypes.REVERT_LOAN_INDEX_START,
	payload: revertData,
});

export const revertLoanIndexDetailsSuccess = (successData: any) => ({
	type: commonLoanProposalActionTypes.REVERT_LOAN_INDEX_SUCCESS,
	payload: successData,
});

export const revertLoanIndexDetailsFailure = (failureData: any) => ({
	type: commonLoanProposalActionTypes.REVERT_LOAN_INDEX_FAILURE,
	payload: failureData,
});

export const revertLoanIndexDetailsResponseResetStart = () => ({
	type: commonLoanProposalActionTypes.REVERT_LOAN_INDEX_RESPONSE_RESET,
});

export const revertLoanIndexDetailsResponseChanged = () => ({
	type: commonLoanProposalActionTypes.REVERT_LOAN_INDEX_RESPONSE_CHANGED,
});

/** ***************** REVERT LOAN INDEX DETAILS END *********************** */

/** ***************** GET GROUP MEMBER LIST START ***************** */
export const getWholeGroupMemberStart = (getData: any) => ({
	type: commonLoanProposalActionTypes.GET_WHOLE_GROUP_MEMBER_LIST_START,
	payload: getData,
});

export const getWholeGroupMemberSuccess = (successData: any) => ({
	type: commonLoanProposalActionTypes.GET_WHOLE_GROUP_MEMBER_LIST_SUCCESS,
	payload: successData,
});

export const getWholeGroupMemberFailure = (failureData: any) => ({
	type: commonLoanProposalActionTypes.GET_WHOLE_GROUP_MEMBER_LIST_FAILURE,
	payload: failureData,
});

export const getWholeGroupMemberResponseReset = () => ({
	type: commonLoanProposalActionTypes.GET_WHOLE_GROUP_MEMBER_LIST_RESPONSE_RESET,
});

export const getWholeGroupMemberResponseChanged = () => ({
	type: commonLoanProposalActionTypes.GET_WHOLE_GROUP_MEMBER_LIST_RESPONSE_CHANGED,
});

/** ***************** GET GROUP MEMBER LIST END ************ */

/** ***************** FETCH PARTICULAR LOAN INDEX START *********************** */
export const fetchParticularLoanIndexStart = (fetchGroupMembers: any) => ({
	type: commonLoanProposalActionTypes.FETCH_PARTICULAR_LOAN_INDEX_START,
	payload: fetchGroupMembers,
});

export const fetchParticularLoanIndexSuccess = (successData: any) => ({
	type: commonLoanProposalActionTypes.FETCH_PARTICULAR_LOAN_INDEX_SUCCESS,
	payload: successData,
});

export const fetchParticularLoanIndexFailure = (failureData: any) => ({
	type: commonLoanProposalActionTypes.FETCH_PARTICULAR_LOAN_INDEX_FAILURE,
	payload: failureData,
});

export const fetchParticularLoanIndexResponseResetStart = () => ({
	type: commonLoanProposalActionTypes.FETCH_PARTICULAR_LOAN_INDEX_RESPONSE_RESET_START,
});

export const fetchParticularLoanIndexResponseChanged = () => ({
	type: commonLoanProposalActionTypes.FETCH_PARTICULAR_LOAN_INDEX_RESPONSE_CHANGED,
});
/** ***************** FETCH PARTICULAR LOAN INDEX END *********************** */

/** ***************** FETCH HOLIDAY LIST START *********************** */
export const fetchHolidayListStart = (addData: any) => ({
	type: commonLoanProposalActionTypes.FETCH_HOLIDAY_LIST_START,
	payload: addData,
});

export const fetchHolidayListSuccess = (successData: any) => ({
	type: commonLoanProposalActionTypes.FETCH_HOLIDAY_LIST_SUCCESS,
	payload: successData,
});

export const fetchHolidayListFailure = (failureData: any) => ({
	type: commonLoanProposalActionTypes.FETCH_HOLIDAY_LIST_FAILURE,
	payload: failureData,
});

export const fetchHolidayListResponseResetStart = () => ({
	type: commonLoanProposalActionTypes.FETCH_HOLIDAY_LIST_RESPONSE_RESET,
});

export const fetchHolidayListResponseChanged = () => ({
	type: commonLoanProposalActionTypes.FETCH_HOLIDAY_LIST_RESPONSE_CHANGED,
});
/** ***************** FETCH HOLIDAY LIST START *********************** */

/** *****************  GET MEMBER LOAN PRODUCT EXIST START *********************** */
export const getMemberLoanProductExistStart = (addData: any) => ({
	type: commonLoanProposalActionTypes.GET_MEMBER_LOAN_PRODUCT_EXIST_START,
	payload: addData,
});

export const getMemberLoanProductExistSuccess = (successData: any) => ({
	type: commonLoanProposalActionTypes.GET_MEMBER_LOAN_PRODUCT_EXIST_SUCCESS,
	payload: successData,
});

export const getMemberLoanProductExistFailure = (failureData: any) => ({
	type: commonLoanProposalActionTypes.GET_MEMBER_LOAN_PRODUCT_EXIST_FAILURE,
	payload: failureData,
});

export const getMemberLoanProductExistResponseResetStart = () => ({
	type: commonLoanProposalActionTypes.GET_MEMBER_LOAN_PRODUCT_EXIST_RESPONSE_RESET,
});

export const getMemberLoanProductExistResponseChanged = () => ({
	type: commonLoanProposalActionTypes.GET_MEMBER_LOAN_PRODUCT_EXIST_RESPONSE_CHANGED,
});
/** *****************  GET MEMBER LOAN PRODUCT EXIST END*********************** */

/** *****************  APPROVE LOAN INDEX DETAILS START *********************** */
export const approveLoanIndexDetailsStart = (addData: any) => ({
	type: commonLoanProposalActionTypes.APPROVE_LOAN_INDEX_START,
	payload: addData,
});

export const approveLoanIndexDetailsSuccess = (successData: any) => ({
	type: commonLoanProposalActionTypes.APPROVE_LOAN_INDEX_SUCCESS,
	payload: successData,
});

export const approveLoanIndexDetailsFailure = (failureData: any) => ({
	type: commonLoanProposalActionTypes.APPROVE_LOAN_INDEX_FAILURE,
	payload: failureData,
});

export const approveLoanIndexDetailsResponseResetStart = () => ({
	type: commonLoanProposalActionTypes.APPROVE_LOAN_INDEX_RESPONSE_RESET_START,
});

export const approveLoanIndexDetailsResponseChanged = () => ({
	type: commonLoanProposalActionTypes.APPROVE_LOAN_INDEX_RESPONSE_CHANGED,
});
/** *****************  APPROVE LOAN INDEX DETAILS END *********************** */

/** ***************** DELETE LOAN INDEX DETAILS START *********************/
export const deleteLoanIndexDetailsStart = (addData: any) => ({
	type: commonLoanProposalActionTypes.DELETE_LOAN_INDEX_START,
	payload: addData,
});

export const deleteLoanIndexDetailsSuccess = (successData: any) => ({
	type: commonLoanProposalActionTypes.DELETE_LOAN_INDEX_SUCCESS,
	payload: successData,
});

export const deleteLoanIndexDetailsFailure = (failureData: any) => ({
	type: commonLoanProposalActionTypes.DELETE_LOAN_INDEX_FAILURE,
	payload: failureData,
});

export const deleteLoanIndexDetailsResponseResetStart = () => ({
	type: commonLoanProposalActionTypes.DELETE_LOAN_INDEX_RESPONSE_RESET_START,
});

export const deleteLoanIndexDetailsResponseChanged = () => ({
	type: commonLoanProposalActionTypes.DELETE_LOAN_INDEX_RESPONSE_CHANGED,
});
/** ***************** DELETE LOAN INDEX DETAILS END *********************/

/** ***************** DELETE MEMBER IN LOAN INDEX DETAILS START *********************/
export const deleteMemberInLoanIndexStart = (addData: any) => ({
	type: commonLoanProposalActionTypes.DELETE_MEMBER_IN_LOAN_INDEX_START,
	payload: addData,
});

export const deleteMemberInLoanIndexSuccess = (successData: any) => ({
	type: commonLoanProposalActionTypes.DELETE_MEMBER_IN_LOAN_INDEX_SUCCESS,
	payload: successData,
});

export const deleteMemberInLoanIndexFailure = (failureData: any) => ({
	type: commonLoanProposalActionTypes.DELETE_MEMBER_IN_LOAN_INDEX_FAILURE,
	payload: failureData,
});

export const deleteMemberInLoanIndexResponseResetStart = () => ({
	type: commonLoanProposalActionTypes.DELETE_MEMBER_IN_LOAN_INDEX_RESPONSE_RESET_START,
});

export const deleteMemberInLoanIndexResponseChanged = () => ({
	type: commonLoanProposalActionTypes.DELETE_MEMBER_IN_LOAN_INDEX_RESPONSE_CHANGED,
});
/** ***************** DELETE MEMBER IN LOAN INDEX DETAILS END *********************/

/** ***************** REVERT LOAN PROPOSAL APPROVE DETAILS START *********************** */
export const revertLoanProposalApproveDetailsStart = (revertData: any) => ({
	type: commonLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_APPROVE_DETAILS_START,
	payload: revertData,
});

export const revertLoanProposalApproveDetailsSuccess = (successData: any) => ({
	type: commonLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_APPROVE_DETAILS_SUCCESS,
	payload: successData,
});

export const revertLoanProposalApproveDetailsFailure = (failureData: any) => ({
	type: commonLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_APPROVE_DETAILS_FAILURE,
	payload: failureData,
});

export const revertLoanProposalApproveDetailsResponseResetStart = () => ({
	type: commonLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_APPROVE_DETAILS_RESPONSE_RESET,
});

export const revertLoanProposalApproveDetailsResponseChanged = () => ({
	type: commonLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_APPROVE_DETAILS_RESPONSE_CHANGED,
});

/** ***************** REVERT CUSTOM PRODUCT LOAN DETAILS END *********************** */

/*********** HDFC CREATE INDIVIDUAL QRCODE START ************************ */
export const createHDFCCreateIndividualLoanQRCodeStart = (fetchData: any) => ({
	type: commonLoanProposalActionTypes.HDFC_CREATE_INDIVIDUAL_LOAN_QRCODE_START,
	payload: fetchData,
});
export const createHDFCCreateIndividualLoanQRCodeSuccess = (successData: any) => ({
	type: commonLoanProposalActionTypes.HDFC_CREATE_INDIVIDUAL_LOAN_QRCODE_SUCCESS,
	payload: successData,
});
export const createHDFCCreateIndividualLoanQRCodeFailure = (failureData: unknown) => ({
	type: commonLoanProposalActionTypes.HDFC_CREATE_INDIVIDUAL_LOAN_QRCODE_FAILURE,
	payload: failureData,
});
export const createHDFCCreateIndividualLoanQRCodeResponseReset = () => ({
	type: commonLoanProposalActionTypes.HDFC_CREATE_INDIVIDUAL_LOAN_QRCODE_RESPONSE_RESET,
});
export const createHDFCCreateIndividualLoanQRCodeResponseChanged = () => ({
	type: commonLoanProposalActionTypes.HDFC_CREATE_INDIVIDUAL_LOAN_QRCODE_RESPONSE_CHANGED,
});
/*********** HDFC CREATE INDIVIDUAL QRCODE END ************************ */

/*********** GET APPRAISAL LOG START ************************ */
export const getAppraisalLogStart = (fetchData: any) => ({
	type: commonLoanProposalActionTypes.GET_APPRAISAL_LOG_START,
	payload: fetchData,
});
export const getAppraisalLogSuccess = (successData: any) => ({
	type: commonLoanProposalActionTypes.GET_APPRAISAL_LOG_SUCCESS,
	payload: successData,
});
export const getAppraisalLogFailure = (failureData: unknown) => ({
	type: commonLoanProposalActionTypes.GET_APPRAISAL_LOG_FAILURE,
	payload: failureData,
});
export const getAppraisalLogResponseReset = () => ({
	type: commonLoanProposalActionTypes.GET_APPRAISAL_LOG_RESPONSE_RESET,
});
export const getAppraisalLogResponseChanged = () => ({
	type: commonLoanProposalActionTypes.GET_APPRAISAL_LOG_RESPONSE_CHANGED,
});
/*********** GET APPRAISAL LOG END ************************ */

/*********** MOVE TO PARTICULAR APPRAISAL START ************************ */
export const moveToParticularAppraisalStart = (moveData: any) => ({
	type: commonLoanProposalActionTypes.MOVE_TO_PARTICULAR_APPRAISAL_START,
	payload: moveData,
});

export const moveToParticularAppraisalSuccess = (successData: any) => ({
	type: commonLoanProposalActionTypes.MOVE_TO_PARTICULAR_APPRAISAL_SUCCESS,
	payload: successData,
});

export const moveToParticularAppraisalFailure = (failureData: unknown) => ({
	type: commonLoanProposalActionTypes.MOVE_TO_PARTICULAR_APPRAISAL_FAILURE,
	payload: failureData,
});

export const moveToParticularAppraisalResponseReset = () => ({
	type: commonLoanProposalActionTypes.MOVE_TO_PARTICULAR_APPRAISAL_RESPONSE_RESET,
});

export const moveToParticularAppraisalResponseChanged = () => ({
	type: commonLoanProposalActionTypes.MOVE_TO_PARTICULAR_APPRAISAL_RESPONSE_CHANGED,
});
/*********** MOVE TO PARTICULAR APPRAISAL END ************************ */

/*********** LOAN APPROVE OTP START ************************ */
export const loanApproveOTPStart = (otpData: any) => ({
	type: commonLoanProposalActionTypes.LOAN_APPROVE_OTP_START,
	payload: otpData,
});
export const loanApproveOTPSuccess = (successData: any) => ({
	type: commonLoanProposalActionTypes.LOAN_APPROVE_OTP_SUCCESS,
	payload: successData,
});
export const loanApproveOTPFailure = (failureData: unknown) => ({
	type: commonLoanProposalActionTypes.LOAN_APPROVE_OTP_FAILURE,
	payload: failureData,
});
export const loanApproveOTPResponseReset = () => ({
	type: commonLoanProposalActionTypes.LOAN_APPROVE_OTP_RESPONSE_RESET,
});
export const loanApproveOTPResponseChanged = () => ({
	type: commonLoanProposalActionTypes.LOAN_APPROVE_OTP_RESPONSE_CHANGED,
});
/*********** LOAN APPROVE OTP END ************************ */
